import { Injectable, inject } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({ providedIn: 'root' })
export class Service {
    private Storage: Storage = inject(Storage);
    private StorageInstance: Storage | null = null;

    async init() {
        if (!this.StorageInstance) {
            this.StorageInstance = this.Storage;
        }

        return this.StorageInstance;
    }

    async set(key: string, value: any) {
        const storage = await this.init();
        return storage.set(key, value);
    }

    async get(key: string) {
        const storage = await this.init();
        return storage.get(key);
    }

    async remove(key: string) {
        const storage = await this.init();
        return storage.remove(key);
    }

    async clear() {
        const storage = await this.init();
        return storage.clear();
    }
}